import { GlobalMarketStatusTable } from '@src/components/StatusTable/GlobalMarketStatusTable';
import { ICON_SIZES, Popover, usePopoverState } from '@talos/kyoko';
import type { CSSProperties } from 'react';
import { GlobalStatusIndicator } from '../StatusIndicator';
import { useNumConnected } from './hooks/useNumConnected';
import { SidebarItem } from './SidebarItem';
import { SidebarPopoverIndicator } from './SidebarPopoverIndicator';
import { SidebarNavItemLabel, SidebarNavItemWrapper } from './styles';

const CONTENT_STYLES: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};
export function SidebarConnectionsItem({ showLabel }: { showLabel: boolean }) {
  const statusIndicatorPopover = usePopoverState({
    trigger: 'hover',
    placement: 'right',
    usePortal: true,
    delay: 200,
    hideDelay: 300,
    noPaddingAndBorder: true,
  });

  const numConnected = useNumConnected();

  return (
    <Popover {...statusIndicatorPopover} contentStyle={CONTENT_STYLES} overflowY="hidden">
      <SidebarNavItemWrapper as="div" data-testid="sidebar-connections-item">
        <SidebarItem>
          <GlobalStatusIndicator showLabel={false} iconSize={ICON_SIZES.MEDIUM} />
          <SidebarPopoverIndicator />
        </SidebarItem>
        {showLabel && <SidebarNavItemLabel>{numConnected}</SidebarNavItemLabel>}
      </SidebarNavItemWrapper>
      <GlobalMarketStatusTable />
    </Popover>
  );
}
